module.exports = __webpack_public_path__ + "img/stage-head.07bf7faf.png";